import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';

const Landing = () => {
    const aText = [
        { text: "Oh, hello world!", speed: 26, pauseAfter: 100 },
        { text: "I'm Jushita Rahman", speed: 26, pauseAfter: 100 },
        { text: "engineer, builder, problem solver", speed: 28, pauseAfter: 120 },
        { text: "Glad you're here :) ", speed: 26, pauseAfter: 0 },
    ];
    const [typeWriterState, setTypewriterState] = useState({
        iIndex: 0,
        iArrLength: aText[0].text.length,
        iScrollAt: 20,
        iTextPos: 0,
        iRow: null,
        content: '',
        isDone: false,
    });
    const [buttonState, setButtonState] = useState({
        showButton: false
    });
    const history = useHistory();

    function handleClick() {
        history.push('/home')
    }


    function typewriter() {
        const copyState = { ...typeWriterState };
        const copyButtuonState = { ...buttonState };
        if (copyState.isDone) {
            return;
        }

        let sContents = ' ';
        copyState.iRow = Math.max(0, copyState.iIndex - copyState.iScrollAt);

        while (copyState.iRow < copyState.iIndex) {
            sContents += aText[copyState.iRow++].text + '<br />';
        }
        copyState.content =
            sContents + aText[copyState.iIndex].text.substring(0, copyState.iTextPos) + "_";
        if (copyState.iTextPos++ === copyState.iArrLength) {
            const isLastLine = copyState.iIndex === aText.length - 1;
            copyState.iTextPos = 0;
            copyState.iIndex++;
            if (isLastLine) {
                copyState.iIndex = aText.length - 1;
                copyState.content = sContents + aText[aText.length - 1].text;
                copyState.isDone = true;
                copyButtuonState.showButton = true;
                setTypewriterState(copyState);
                setButtonState(copyButtuonState);
            } else if (copyState.iIndex !== aText.length) {
                copyState.iArrLength = aText[copyState.iIndex].text.length;
                const pause = aText[copyState.iIndex - 1].pauseAfter ?? 400;
                setTimeout(() => setTypewriterState(copyState), pause);
                setTimeout(() => setButtonState(copyButtuonState), 0);
            }

        } else {
            const speed = aText[copyState.iIndex].speed ?? 80;
            setTimeout(() => {
                setTypewriterState(copyState);
            }, speed);
        }
    }

    useEffect(() => {
        typewriter();
        return () => {

        };
    }, [typeWriterState]);

    return (
        <>
            <div className="landing__page">

                <link href="https://fonts.googleapis.com/css?family=Waiting+for+the+Sunrise" rel="stylesheet" type="text/css" />
                <div className="landing-container">
                    <h3 className="sunrise-font" id="typedtext" dangerouslySetInnerHTML={{ __html: typeWriterState.content }}></h3>
                    {buttonState.showButton === true ? <button className="btn btn-discover" type="button" onClick={() => handleClick()}>Discover More</button> : ''}
                </div>
            </div>
        </>
    )
}

export default Landing;
